const avatarColors = [
    '#e05252', '#e08c3a', '#c9b83a', '#52b852',
    '#3ab8a8', '#3a78e0', '#8c3ae0', '#c93a8c',
];

export function avatarColor(str) {
    if (!str) return avatarColors[0];
    let hash = 0;
    for (const ch of str) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
    return avatarColors[hash % avatarColors.length];
}

export function computeInitials(str) {
    if (!str) return '??';
    const words = str.split(/[\s\-]+/).filter(w => w.length >= 1 && !/^[&+.]$/.test(w));
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return str.replace(/[&+.]/g, '').slice(0, 2).toUpperCase();
}